
import { useState } from 'react';
import Sidebar from '../../components/feature/Sidebar';
import CompanyTab from './components/CompanyTab';
import UserTab from './components/UserTab';
import SystemTab from './components/SystemTab';

interface Camera {
  id: number;
  name: string;
  ip: string;
  port: string;
  protocol: string;
  location: string;
  status: string;
}

interface Scale {
  id: number;
  name: string;
  brand: string;
  ip: string;
  port: string;
  maxLoad: string;
  status: string;
}

interface Station {
  id: number;
  name: string;
  address: string;
  image: string;
  manager: string;
  phone: string;
  capacity: number;
  capacityUnit: string;
  warehouseCount: number;
  status: string;
  cameras: Camera[];
  scales: Scale[];
  remark: string;
  lat: string;
  lng: string;
}

const stationsData: Station[] = [
  {
    id: 1,
    name: '中原路收购站',
    address: '河南省郑州市金水区中原路188号',
    image:
      'https://public.readdy.ai/ai/img_res/6489b1a773d54cff266963181b637976.jpg',
    manager: '王建国',
    phone: '138-0001-0001',
    capacity: 5000,
    capacityUnit: '吨',
    warehouseCount: 3,
    status: '运营中',
    lat: '34.7466',
    lng: '113.6253',
    cameras: [
      {
        id: 1,
        name: '大门口摄像头',
        ip: '192.168.1.101',
        port: '8080',
        protocol: 'RTSP',
        location: '大门入口',
        status: '在线',
      },
      {
        id: 2,
        name: '地磅区摄像头',
        ip: '192.168.1.102',
        port: '8080',
        protocol: 'RTSP',
        location: '地磅区域',
        status: '在线',
      },
      {
        id: 3,
        name: '仓库1号摄像头',
        ip: '192.168.1.103',
        port: '8080',
        protocol: 'RTSP',
        location: '1号仓库内',
        status: '离线',
      },
    ],
    scales: [
      {
        id: 1,
        name: '1号地磅',
        brand: '梅特勒-托利多',
        ip: '192.168.1.201',
        port: '9090',
        maxLoad: '100吨',
        status: '正常',
      },
      {
        id: 2,
        name: '2号地磅',
        brand: '耀华电子',
        ip: '192.168.1.202',
        port: '9090',
        maxLoad: '60吨',
        status: '正常',
      },
    ],
    remark: '主要收购站，承担全市60%的粮食收购任务',
  },
  {
    id: 2,
    name: '农业路收购站',
    address: '河南省郑州市惠济区农业路56号',
    image:
      'https://readdy.ai/api/search-image?query=grain%20storage%20facility%20agricultural%20warehouse%20China%20countryside%20large%20silos%20loading%20area%20trucks%20sunny%20day%20wide%20angle%20realistic%20photo&width=600&height=300&seq=station2&orientation=landscape',
    manager: '刘秀英',
    phone: '138-0001-0002',
    capacity: 3_000,
    capacityUnit: '吨',
    warehouseCount: 2,
    status: '运营中',
    lat: '34.8312',
    lng: '113.5987',
    cameras: [
      {
        id: 1,
        name: '入口摄像头',
        ip: '192.168.2.101',
        port: '8080',
        protocol: 'RTSP',
        location: '大门入口',
        status: '在线',
      },
    ],
    scales: [
      {
        id: 1,
        name: '1号地磅',
        brand: '耀华电子',
        ip: '192.168.2.201',
        port: '9090',
        maxLoad: '80吨',
        status: '正常',
      },
    ],
    remark: '北部区域收购站',
  },
  {
    id: 3,
    name: '南部收购站',
    address: '河南省郑州市新郑市龙湖镇工业路12号',
    image:
      'https://readdy.ai/api/search-image?query=rural%20grain%20collection%20center%20China%20farmland%20background%20storage%20building%20concrete%20floor%20weighing%20area%20clear%20sky%20realistic%20photo&width=600&height=300&seq=station3&orientation=landscape',
    manager: '陈志远',
    phone: '138-0001-0003',
    capacity: 2000,
    capacityUnit: '吨',
    warehouseCount: 1,
    status: '季节性运营',
    lat: '34.4021',
    lng: '113.7412',
    cameras: [],
    scales: [
      {
        id: 1,
        name: '1号地磅',
        brand: '大华',
        ip: '192.168.3.201',
        port: '9090',
        maxLoad: '50吨',
        status: '维修中',
      },
    ],
    remark: '夏秋收购季节启用',
  },
];

export default function Settings() {
  const [activeTab, setActiveTab] = useState<'company' | 'user' | 'station' | 'system'>('company');
  const [showSaveSuccess, setShowSaveSuccess] = useState(false);
  const [saveSuccessMsg, setSaveSuccessMsg] = useState('保存成功');

  // Station states
  const [stations, setStations] = useState<Station[]>(stationsData);
  const [showStationModal, setShowStationModal] = useState(false);
  const [editingStation, setEditingStation] = useState<Station | null>(null);
  const [stationModalTab, setStationModalTab] = useState<'basic' | 'camera' | 'scale'>('basic');
  const [showStationDeleteConfirm, setShowStationDeleteConfirm] = useState(false);
  const [deletingStationId, setDeletingStationId] = useState<number | null>(null);
  const [showAddCameraForm, setShowAddCameraForm] = useState(false);
  const [showAddScaleForm, setShowAddScaleForm] = useState(false);
  const [newCamera, setNewCamera] = useState<Partial<Camera>>({
    name: '',
    ip: '',
    port: '8080',
    protocol: 'RTSP',
    location: '',
    status: '在线',
  });
  const [newScale, setNewScale] = useState<Partial<Scale>>({
    name: '',
    brand: '',
    ip: '',
    port: '9090',
    maxLoad: '',
    status: '正常',
  });

  const showSuccess = (msg: string) => {
    setSaveSuccessMsg(msg);
    setShowSaveSuccess(true);
    setTimeout(() => setShowSaveSuccess(false), 2500);
  };

  const handleOpenAddStation = () => {
    setEditingStation({
      id: Date.now(),
      name: '',
      address: '',
      image: '',
      manager: '',
      phone: '',
      capacity: 0,
      capacityUnit: '吨',
      warehouseCount: 1,
      status: '运营中',
      cameras: [],
      scales: [],
      remark: '',
      lat: '',
      lng: '',
    });
    setStationModalTab('basic');
    setShowStationModal(true);
  };

  const handleEditStation = (station: Station) => {
    setEditingStation({ ...station, cameras: [...station.cameras], scales: [...station.scales] });
    setStationModalTab('basic');
    setShowStationModal(true);
  };

  const handleSaveStation = () => {
    if (!editingStation) return;
    setStations((prev) => {
      const exists = prev.find((s) => s.id === editingStation.id);
      return exists
        ? prev.map((s) => (s.id === editingStation.id ? editingStation : s))
        : [...prev, editingStation];
    });
    setShowStationModal(false);
    setEditingStation(null);
    showSuccess('站点信息保存成功');
  };

  const handleDeleteStation = () => {
    if (deletingStationId !== null) {
      setStations((prev) => prev.filter((s) => s.id !== deletingStationId));
    }
    setShowStationDeleteConfirm(false);
    setDeletingStationId(null);
    showSuccess('站点已删除');
  };

  const handleAddCamera = () => {
    if (!editingStation || !newCamera.name || !newCamera.ip) return;
    const cam: Camera = {
      id: Date.now(),
      name: newCamera.name!,
      ip: newCamera.ip!,
      port: newCamera.port || '8080',
      protocol: newCamera.protocol || 'RTSP',
      location: newCamera.location || '',
      status: newCamera.status || '在线',
    };
    setEditingStation({ ...editingStation, cameras: [...editingStation.cameras, cam] });
    setNewCamera({ name: '', ip: '', port: '8080', protocol: 'RTSP', location: '', status: '在线' });
    setShowAddCameraForm(false);
  };

  const handleAddScale = () => {
    if (!editingStation || !newScale.name || !newScale.ip) return;
    const scale: Scale = {
      id: Date.now(),
      name: newScale.name!,
      brand: newScale.brand || '',
      ip: newScale.ip!,
      port: newScale.port || '9090',
      maxLoad: newScale.maxLoad || '',
      status: newScale.status || '正常',
    };
    setEditingStation({ ...editingStation, scales: [...editingStation.scales, scale] });
    setNewScale({ name: '', brand: '', ip: '', port: '9090', maxLoad: '', status: '正常' });
    setShowAddScaleForm(false);
  };

  return (
    <div className="flex min-h-screen bg-[#f7f8fa]">
      <Sidebar />
      <div className="flex-1 ml-64">
        <div className="p-8">
          {/* 页头 */}
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-gray-800">系统设置</h1>
            <p className="text-gray-500 mt-1 text-sm">配置企业信息、用户权限和系统参数</p>
          </div>

          {/* 全局成功提示 */}
          {showSaveSuccess && (
            <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[100] bg-teal-600 text-white px-6 py-3 rounded-xl shadow-lg flex items-center space-x-2">
              <i className="ri-check-line text-lg"></i>
              <span className="text-sm font-medium">{saveSuccessMsg}</span>
            </div>
          )}

          <div className="flex gap-6">
            {/* 左侧导航 */}
            <div className="w-56 flex-shrink-0">
              <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-2 sticky top-8">
                {(
                  [
                    { key: 'company', icon: 'ri-building-line', label: '企业信息', badge: '' },
                    { key: 'user', icon: 'ri-user-settings-line', label: '用户管理', badge: '' },
                    { key: 'station', icon: 'ri-store-2-line', label: '收购站点', badge: '' },
                    { key: 'system', icon: 'ri-settings-3-line', label: '系统配置', badge: '续费' },
                  ] as const
                ).map((item) => (
                  <button
                    key={item.key}
                    onClick={() => setActiveTab(item.key)}
                    className={`w-full flex items-center justify-between px-4 py-3 rounded-lg text-sm font-medium transition-all mb-1 cursor-pointer ${
                      activeTab === item.key
                        ? 'bg-teal-50 text-teal-700 border border-teal-200'
                        : 'text-gray-600 hover:bg-gray-50'
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <i className={`${item.icon} text-lg`}></i>
                      <span>{item.label}</span>
                    </div>
                    {item.badge && (
                      <span className="px-1.5 py-0.5 bg-amber-100 text-amber-600 rounded text-xs font-medium">
                        {item.badge}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* 右侧内容 */}
            <div className="flex-1 min-w-0">
              {activeTab === 'company' && <CompanyTab showSuccess={showSuccess} />}
              {activeTab === 'user' && <UserTab showSuccess={showSuccess} />}
              {activeTab === 'system' && <SystemTab showSuccess={showSuccess} />}

              {/* ===== 收购站点 ===== */}
              {activeTab === 'station' && (
                <div>
                  <div className="bg-white rounded-xl shadow-sm border border-gray-100 mb-5">
                    <div className="p-6 border-b border-gray-200 flex items-center justify-between">
                      <div>
                        <h2 className="text-lg font-semibold text-gray-800">收购站点管理</h2>
                        <p className="text-sm text-gray-500 mt-1">
                          管理各收购站点的基本信息、设备配置和仓储容量
                        </p>
                      </div>
                      <button
                        onClick={handleOpenAddStation}
                        className="px-5 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-all text-sm font-medium whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-add-line mr-2"></i>新增站点
                      </button>
                    </div>
                    <div className="grid grid-cols-4 divide-x divide-gray-100 border-b border-gray-100">
                      {[
                        { label: '站点总数', value: stations.length, icon: 'ri-store-2-line', color: 'text-teal-600' },
                        {
                          label: '运营中',
                          value: stations.filter((s) => s.status === '运营中').length,
                          icon: 'ri-checkbox-circle-line',
                          color: 'text-green-600',
                        },
                        {
                          label: '总仓储容量',
                          value: `${stations.reduce((a, s) => a + s.capacity, 0).toLocaleString()}吨`,
                          icon: 'ri-archive-line',
                          color: 'text-amber-600',
                        },
                        {
                          label: '摄像头总数',
                          value: stations.reduce((a, s) => a + s.cameras.length, 0),
                          icon: 'ri-camera-line',
                          color: 'text-indigo-500',
                        },
                      ].map((item, i) => (
                        <div key={i} className="p-5 flex items-center space-x-3">
                          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-gray-50">
                            <i className={`${item.icon} ${item.color} text-xl`}></i>
                          </div>
                          <div>
                            <p className="text-xs text-gray-500">{item.label}</p>
                            <p className="text-lg font-bold text-gray-800">{item.value}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="space-y-4">
                    {stations.map((station) => (
                      <div
                        key={station.id}
                        className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-all"
                      >
                        <div className="flex">
                          <div className="w-52 h-40 flex-shrink-0 relative">
                            <img src={station.image} alt={station.name} className="w-full h-full object-cover object-top" />
                            <span
                              className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium ${
                                station.status === '运营中'
                                  ? 'bg-green-500 text-white'
                                  : station.status === '季节性运营'
                                  ? 'bg-amber-500 text-white'
                                  : 'bg-gray-400 text-white'
                              }`}
                            >
                              {station.status}
                            </span>
                          </div>
                          <div className="flex-1 p-5">
                            <div className="flex items-start justify-between mb-3">
                              <div>
                                <h3 className="text-base font-semibold text-gray-800">{station.name}</h3>
                                <p className="text-sm text-gray-500 mt-1 flex items-center">
                                  <i className="ri-map-pin-line mr-1 text-gray-400"></i>
                                  {station.address}
                                </p>
                              </div>
                              <div className="flex items-center space-x-2">
                                <button
                                  onClick={() => handleEditStation(station)}
                                  className="px-4 py-1.5 bg-teal-50 text-teal-700 rounded-lg hover:bg-teal-100 transition-colors text-xs font-medium whitespace-nowrap cursor-pointer"
                                >
                                  <i className="ri-edit-line mr-1"></i>编辑
                                </button>
                                <button
                                  onClick={() => {
                                    setDeletingStationId(station.id);
                                    setShowStationDeleteConfirm(true);
                                  }}
                                  className="px-4 py-1.5 bg-rose-50 text-rose-600 rounded-lg hover:bg-rose-100 transition-colors text-xs font-medium whitespace-nowrap cursor-pointer"
                                >
                                  <i className="ri-delete-bin-line mr-1"></i>删除
                                </button>
                              </div>
                            </div>
                            <div className="grid grid-cols-4 gap-3 mb-3">
                              {[
                                { icon: 'ri-user-line', color: 'text-teal-600', bg: 'bg-teal-50', label: '负责人', value: station.manager },
                                { icon: 'ri-phone-line', color: 'text-teal-600', bg: 'bg-teal-50', label: '联系方式', value: station.phone },
                                {
                                  icon: 'ri-archive-line',
                                  color: 'text-amber-600',
                                  bg: 'bg-amber-50',
                                  label: '仓储容量',
                                  value: `${station.capacity.toLocaleString()}${station.capacityUnit}`,
                                },
                                { icon: 'ri-building-4-line', color: 'text-indigo-500', bg: 'bg-indigo-50', label: '仓库数量', value: `${station.warehouseCount} 个` },
                              ].map((info, i) => (
                                <div key={i} className="flex items-center space-x-2">
                                  <div className={`${info.bg} w-7 h-7 flex items-center justify-center rounded-lg`}>
                                    <i className={`${info.icon} ${info.color} text-sm`}></i>
                                  </div>
                                  <div>
                                    <p className="text-xs text-gray-400">{info.label}</p>
                                    <p className="text-xs font-medium text-gray-700">{info.value}</p>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="flex items-center space-x-4 pt-3 border-t border-gray-100 text-xs text-gray-500">
                              <span className="flex items-center space-x-1">
                                <i className="ri-camera-line text-gray-400"></i>
                                <span>
                                  摄像头 <strong className="text-gray-700">{station.cameras.length}</strong> 路
                                </span>
                                <span className="text-green-600 ml-1">{station.cameras.filter((c) => c.status === '在线').length} 在线</span>
                              </span>
                              <span className="flex items-center space-x-1">
                                <i className="ri-scales-line text-gray-400"></i>
                                <span>
                                  地磅 <strong className="text-gray-700">{station.scales.length}</strong> 台
                                </span>
                                <span className="text-green-600 ml-1">{station.scales.filter((s) => s.status === '正常').length} 正常</span>
                              </span>
                              {station.remark && (
                                <span className="ml-auto text-gray-400 truncate max-w-xs">
                                  <i className="ri-file-text-line mr-1"></i>
                                  {station.remark}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ===== 站点编辑弹窗 ===== */}
      {showStationModal && editingStation && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[92vh] flex flex-col">
            <div className="border-b border-gray-200 px-6 py-5 flex items-center justify-between flex-shrink-0">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-teal-100 rounded-xl flex items-center justify-center">
                  <i className="ri-store-2-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-800">
                    {editingStation.name || '新增收购站点'}
                  </h3>
                  <p className="text-xs text-gray-500 mt-0.5">配置站点基本信息、摄像头和地磅设备</p>
                </div>
              </div>
              <button
                onClick={() => {
                  setShowStationModal(false);
                  setEditingStation(null);
                }}
                className="w-9 h-9 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            <div className="flex border-b border-gray-200 px-6 flex-shrink-0">
              {(
                [
                  { key: 'basic', icon: 'ri-information-line', label: '基本信息' },
                  { key: 'camera', icon: 'ri-camera-line', label: `摄像头配置 (${editingStation.cameras.length})` },
                  { key: 'scale', icon: 'ri-scales-line', label: `地磅接入 (${editingStation.scales.length})` },
                ] as const
              ).map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setStationModalTab(tab.key)}
                  className={`flex items-center space-x-2 px-5 py-3.5 text-sm font-medium border-b-2 transition-all cursor-pointer whitespace-nowrap ${
                    stationModalTab === tab.key
                      ? 'border-teal-600 text-teal-700'
                      : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`}
                >
                  <i className={tab.icon}></i>
                  <span>{tab.label}</span>
                </button>
              ))}
            </div>

            <div className="flex-1 overflow-y-auto p-6">
              {stationModalTab === 'basic' && (
                <div className="grid grid-cols-2 gap-4">
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">
                      站点名称 <span className="text-rose-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={editingStation.name}
                      onChange={(e) => setEditingStation({ ...editingStation, name: e.target.value })}
                      placeholder="请输入站点名称"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">站点地址</label>
                    <input
                      type="text"
                      value={editingStation.address}
                      onChange={(e) => setEditingStation({ ...editingStation, address: e.target.value })}
                      placeholder="详细地址"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    />
                  </div>
                  {[
                    { label: '负责人', key: 'manager' },
                    { label: '联系电话', key: 'phone' },
                    { label: '纬度', key: 'lat' },
                    { label: '经度', key: 'lng' },
                  ].map((f) => (
                    <div key={f.key}>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">{f.label}</label>
                      <input
                        type="text"
                        value={editingStation[f.key as keyof Station] as string}
                        onChange={(e) => setEditingStation({ ...editingStation, [f.key]: e.target.value })}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                      />
                    </div>
                  ))}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">仓储容量（吨）</label>
                    <input
                      type="number"
                      value={editingStation.capacity}
                      onChange={(e) => setEditingStation({ ...editingStation, capacity: Number(e.target.value) })}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">仓库数量</label>
                    <input
                      type="number"
                      value={editingStation.warehouseCount}
                      onChange={(e) => setEditingStation({ ...editingStation, warehouseCount: Number(e.target.value) })}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">运营状态</label>
                    <select
                      value={editingStation.status}
                      onChange={(e) => setEditingStation({ ...editingStation, status: e.target.value })}
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent cursor-pointer"
                    >
                      <option>运营中</option>
                      <option>季节性运营</option>
                      <option>暂停运营</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">站点图片URL</label>
                    <input
                      type="text"
                      value={editingStation.image}
                      onChange={(e) => setEditingStation({ ...editingStation, image: e.target.value })}
                      placeholder="图片链接地址"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">备注</label>
                    <textarea
                      rows={3}
                      value={editingStation.remark}
                      onChange={(e) => {
                        if (e.target.value.length <= 500) setEditingStation({ ...editingStation, remark: e.target.value });
                      }}
                      maxLength={500}
                      placeholder="站点补充说明"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm resize-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    />
                    <p className="text-xs text-gray-400 mt-1 text-right">{editingStation.remark.length}/500</p>
                  </div>
                </div>
              )}

              {stationModalTab === 'camera' && (
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <p className="text-sm text-gray-500">配置站点监控摄像头的网络接入信息</p>
                    <button
                      onClick={() => setShowAddCameraForm(true)}
                      className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-xs font-medium whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-add-line mr-1"></i>添加摄像头
                    </button>
                  </div>
                  {showAddCameraForm && (
                    <div className="mb-5 p-4 bg-teal-50 border border-teal-200 rounded-xl">
                      <h5 className="text-sm font-semibold text-teal-700 mb-3">新增摄像头</h5>
                      <div className="grid grid-cols-3 gap-3 mb-3">
                        {[
                          { label: '摄像头名称 *', key: 'name', placeholder: '如：大门口摄像头' },
                          { label: 'IP地址 *', key: 'ip', placeholder: '192.168.1.101' },
                          { label: '端口号', key: 'port', placeholder: '8080' },
                          { label: '安装位置', key: 'location', placeholder: '如：大门入口' },
                        ].map((f) => (
                          <div key={f.key}>
                            <label className="block text-xs font-medium text-gray-600 mb-1">{f.label}</label>
                            <input
                              type="text"
                              value={newCamera[f.key as keyof typeof newCamera] || ''}
                              onChange={(e) => setNewCamera({ ...newCamera, [f.key]: e.target.value })}
                              placeholder={f.placeholder}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-xs focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                            />
                          </div>
                        ))}
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">协议</label>
                          <select
                            value={newCamera.protocol}
                            onChange={(e) => setNewCamera({ ...newCamera, protocol: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-xs focus:ring-2 focus:ring-teal-500 focus:border-transparent cursor-pointer"
                          >
                            <option>RTSP</option>
                            <option>HTTP</option>
                            <option>ONVIF</option>
                            <option>GB28181</option>
                          </select>
                        </div>
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">状态</label>
                          <select
                            value={newCamera.status}
                            onChange={(e) => setNewCamera({ ...newCamera, status: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-xs focus:ring-2 focus:ring-teal-500 focus:border-transparent cursor-pointer"
                          >
                            <option>在线</option>
                            <option>离线</option>
                            <option>故障</option>
                          </select>
                        </div>
                      </div>
                      <div className="flex items-center justify-end space-x-2">
                        <button
                          onClick={() => setShowAddCameraForm(false)}
                          className="px-4 py-1.5 border border-gray-300 text-gray-600 rounded-lg text-xs hover:bg-gray-50 cursor-pointer whitespace-nowrap"
                        >
                          取消
                        </button>
                        <button onClick={handleAddCamera} className="px-4 py-1.5 bg-teal-600 text-white rounded-lg text-xs hover:bg-teal-700 cursor-pointer whitespace-nowrap">
                          确认添加
                        </button>
                      </div>
                    </div>
                  )}
                  {editingStation.cameras.length === 0 ? (
                    <div className="text-center py-12 text-gray-400">
                      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                        <i className="ri-camera-off-line text-3xl"></i>
                      </div>
                      <p className="text-sm">暂未配置摄像头</p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {editingStation.cameras.map((cam, idx) => (
                        <div key={cam.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-xl hover:border-teal-200 transition-all">
                          <div className="flex items-center space-x-3">
                            <div className="w-9 h-9 bg-indigo-50 rounded-lg flex items-center justify-center">
                              <i className="ri-camera-line text-indigo-500"></i>
                            </div>
                            <div>
                              <p className="text-sm font-medium text-gray-800">{cam.name}</p>
                              <p className="text-xs text-gray-500 mt-0.5">{cam.location}</p>
                            </div>
                          </div>
                          <div className="flex items-center space-x-5 text-xs text-gray-500">
                            <span>
                              <span className="text-gray-400">地址：</span>
                              <span className="font-mono text-gray-700">{cam.ip}:{cam.port}</span>
                            </span>
                            <span>
                              <span className="text-gray-400">协议：</span>
                              <span className="text-gray-700">{cam.protocol}</span>
                            </span>
                            <span
                              className={`px-2.5 py-1 rounded-full font-medium ${
                                cam.status === '在线'
                                  ? 'bg-green-100 text-green-700'
                                  : cam.status === '离线'
                                  ? 'bg-gray-100 text-gray-600'
                                  : 'bg-rose-100 text-rose-600'
                              }`}
                            >
                              {cam.status}
                            </span>
                            <button
                              onClick={() =>
                                setEditingStation({
                                  ...editingStation,
                                  cameras: editingStation.cameras.filter((_, i) => i !== idx),
                                })
                              }
                              className="w-7 h-7 flex items-center justify-center text-rose-400 hover:bg-rose-50 rounded-lg transition-colors cursor-pointer"
                            >
                              <i className="ri-delete-bin-line"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {stationModalTab === 'scale' && (
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <p className="text-sm text-gray-500">配置地磅设备的网络接入和参数信息</p>
                    <button
                      onClick={() => setShowAddScaleForm(true)}
                      className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors text-xs font-medium whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-add-line mr-1"></i>添加地磅
                    </button>
                  </div>
                  {showAddScaleForm && (
                    <div className="mb-5 p-4 bg-teal-50 border border-teal-200 rounded-xl">
                      <h5 className="text-sm font-semibold text-teal-700 mb-3">新增地磅</h5>
                      <div className="grid grid-cols-3 gap-3 mb-3">
                        {[
                          { label: '设备名称 *', key: 'name', placeholder: '如：1号地磅' },
                          { label: '品牌型号', key: 'brand', placeholder: '如：梅特勒-托利多' },
                          { label: 'IP地址 *', key: 'ip', placeholder: '192.168.1.201' },
                          { label: '端口号', key: 'port', placeholder: '9090' },
                          { label: '最大称重', key: 'maxLoad', placeholder: '如：100吨' },
                        ].map((f) => (
                          <div key={f.key}>
                            <label className="block text-xs font-medium text-gray-600 mb-1">{f.label}</label>
                            <input
                              type="text"
                              value={newScale[f.key as keyof typeof newScale] || ''}
                              onChange={(e) => setNewScale({ ...newScale, [f.key]: e.target.value })}
                              placeholder={f.placeholder}
                              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-xs focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                            />
                          </div>
                        ))}
                        <div>
                          <label className="block text-xs font-medium text-gray-600 mb-1">状态</label>
                          <select
                            value={newScale.status}
                            onChange={(e) => setNewScale({ ...newScale, status: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-xs focus:ring-2 focus:ring-teal-500 focus:border-transparent cursor-pointer"
                          >
                            <option>正常</option>
                            <option>维修中</option>
                            <option>停用</option>
                          </select>
                        </div>
                      </div>
                      <div className="flex items-center justify-end space-x-2">
                        <button
                          onClick={() => setShowAddScaleForm(false)}
                          className="px-4 py-1.5 border border-gray-300 text-gray-600 rounded-lg text-xs hover:bg-gray-50 cursor-pointer whitespace-nowrap"
                        >
                          取消
                        </button>
                        <button onClick={handleAddScale} className="px-4 py-1.5 bg-teal-600 text-white rounded-lg text-xs hover:bg-teal-700 cursor-pointer whitespace-nowrap">
                          确认添加
                        </button>
                      </div>
                    </div>
                  )}
                  {editingStation.scales.length === 0 ? (
                    <div className="text-center py-12 text-gray-400">
                      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                        <i className="ri-scales-line text-3xl"></i>
                      </div>
                      <p className="text-sm">暂未配置地磅设备</p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {editingStation.scales.map((scale, idx) => (
                        <div key={scale.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-xl hover:border-teal-200 transition-all">
                          <div className="flex items-center space-x-3">
                            <div className="w-9 h-9 bg-amber-50 rounded-lg flex items-center justify-center">
                              <i className="ri-scales-line text-amber-600"></i>
                            </div>
                            <div>
                              <p className="text-sm font-medium text-gray-800">{scale.name}</p>
                              <p className="text-xs text-gray-500 mt-0.5">{scale.brand}</p>
                            </div>
                          </div>
                          <div className="flex items-center space-x-5 text-xs text-gray-500">
                            <span>
                              <span className="text-gray-400">地址：</span>
                              <span className="font-mono text-gray-700">{scale.ip}:{scale.port}</span>
                            </span>
                            <span>
                              <span className="text-gray-400">最大称重：</span>
                              <span className="text-gray-700">{scale.maxLoad}</span>
                            </span>
                            <span
                              className={`px-2.5 py-1 rounded-full font-medium ${
                                scale.status === '正常'
                                  ? 'bg-green-100 text-green-700'
                                  : scale.status === '维修中'
                                  ? 'bg-amber-100 text-amber-700'
                                  : 'bg-gray-100 text-gray-600'
                              }`}
                            >
                              {scale.status}
                            </span>
                            <button
                              onClick={() =>
                                setEditingStation({
                                  ...editingStation,
                                  scales: editingStation.scales.filter((_, i) => i !== idx),
                                })
                              }
                              className="w-7 h-7 flex items-center justify-center text-rose-400 hover:bg-rose-50 rounded-lg transition-colors cursor-pointer"
                            >
                              <i className="ri-delete-bin-line"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="border-t border-gray-200 px-6 py-4 flex items-center justify-between flex-shrink-0">
              <p className="text-xs text-gray-400">
                <i className="ri-time-line mr-1"></i>修改后立即生效
              </p>
              <div className="flex items-center space-x-3">
                <button
                  onClick={() => {
                    setShowStationModal(false);
                    setEditingStation(null);
                  }}
                  className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
                >
                  取消
                </button>
                <button
                  onClick={handleSaveStation}
                  className="px-8 py-2.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 hover:shadow-md transition-all text-sm font-medium whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-save-line mr-2"></i>保存站点
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 站点删除确认 */}
      {showStationDeleteConfirm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-alert-line text-2xl text-rose-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-800 text-center mb-2">确认删除站点？</h3>
            <p className="text-sm text-gray-500 text-center mb-6">
              删除后该站点的所有配置信息将被移除，此操作不可恢复
            </p>
            <div className="flex items-center space-x-3">
              <button
                onClick={() => {
                  setShowStationDeleteConfirm(false);
                  setDeletingStationId(null);
                }}
                className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                取消
              </button>
              <button onClick={handleDeleteStation} className="flex-1 px-4 py-2.5 bg-rose-600 text-white rounded-lg hover:bg-rose-700 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer">
                确认删除
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
